import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-5">
      <div className="card-lux p-10 max-w-md text-center" data-testid="payment-cancel">
        <XCircle className="mx-auto text-stone-400" size={48} />
        <h1 className="font-serif text-3xl text-forest mt-4">Payment cancelled</h1>
        <p className="text-stone-500 mt-3">No charge was made. Your reservation is still held as pending — you can complete payment anytime.</p>
        <Link to="/booking" className="btn-primary mt-6 inline-flex">Return to booking</Link>
      </div>
    </div>
  );
}
